import { tap } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@intranet/modules/users/user.service';
import { User, UserRoleMember } from '@intranet/modules/users/user.types';
import { LoginService } from '../..';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

@Component({
    selector: 'admin-users',
    templateUrl: './admin-users.component.html',
    styleUrls: ['./admin-users.component.scss'],
})
export class AdminUsersComponent implements OnInit {
    isLoading: boolean = false;
    users: User[] | null;
    allusers: User[];
    roles: UserRoleMember[];
    error: string | null;
    selectedUser: User | null;
    showActive = true;
    showDialog = false;

    constructor(
        protected loginService: LoginService,
        private userService: UserService,
        private router: Router,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this._loadUsers();

        // Register hotkey for "Add User" (Ctrl + Shift + A)
        this.hotkeyService.registerHotkey('ctrl+shift+a', 'Add User', () => {
            this.onClickToggle();
        });
    }

    onUserSelected(user: User) {
        this.selectedUser = user;
        this.showDialog = true;
    }

    onUserUpdated(user: User) {
        this._loadUsers();
    }

    onStatus(status: string | 'active'): void {
        this._filter(status);
    }

    onClickToggle() {
        this.selectedUser = null;
        this.showDialog = true;
    }

    private _filter(status: string) {
        this.users = this.allusers.filter((u) => status === 'active' ? u.active : !u.active);
    }

    private _loadUsers() {
        this.isLoading = true;
        this.userService
            .getUsers()
            .pipe(
                tap(response => {
                    this.allusers = response.users;
                    this.roles = response.roles;
                    this._filter('active');
                }))
            .subscribe({
                error: (err) => (this.error = err),
                complete: () => (this.isLoading = false)
            });
    }
}
